export const common = {
  it: {
    greeting: "Ciao, sono Victor Lazari",
    subtitle: "Automatizzo processi, dati e report per PMI e system integrator",
    downloadCV: "Scarica il CV",
    contact: "Contattami",
    hero: {
      badge: "Disponibile per nuovi progetti — Ravenna · tutta Italia in remoto",
      title1: "Automatizzo i processi che",
      titleAccent: "rallentano la tua azienda.",
      subtitle:
        "App gestionali, dashboard e automazioni per PMI e system integrator. Progetti a prezzo fisso, consegnati in settimane — con gli strumenti Microsoft che probabilmente già paghi.",
      ctaPrimary: "Scrivimi su WhatsApp",
      ctaSecondary: "Vedi i servizi",
      photoBadgeTitle: "Ex Baker Hughes",
      photoBadgeSub: "Software Engineer",
      trustedLabel: "Esperienza in",
      stats: [
        { value: "200+", label: "processi aziendali supportati" },
        { value: "−60%", label: "lavoro manuale eliminato" },
        { value: "7+", label: "anni di esperienza" },
        { value: "4", label: "lingue parlate" }
      ]
    },
    about: {
      title: "Chi Sono",
      description: "Ingegnere del software specializzato in AI e automazione. Sviluppo soluzioni che trasformano i dati in valore."
    },
    expertise: {
      ai: "Power Apps",
      automation: "Power Automate",
      prototyping: "Power BI & SQL",
      machineLearning: "Azure & Integrazioni"
    },
    blog: {
      title: "Blog & Articoli",
      backToList: "Torna alla lista",
      readMore: "Leggi l'articolo"
    }
  },
  en: {
    greeting: "Hello, I'm Victor Lazari",
    subtitle: "I automate processes, data and reporting for SMEs and system integrators",
    downloadCV: "Download CV",
    contact: "Contact Me",
    hero: {
      badge: "Available for new projects — Ravenna · remote across Italy & EU",
      title1: "I automate the processes",
      titleAccent: "slowing your company down.",
      subtitle:
        "Business apps, dashboards and automations for SMEs and system integrators. Fixed-price projects, delivered in weeks — built on the Microsoft tools you probably already pay for.",
      ctaPrimary: "Message me on WhatsApp",
      ctaSecondary: "See services",
      photoBadgeTitle: "Ex Baker Hughes",
      photoBadgeSub: "Software Engineer",
      trustedLabel: "Experience at",
      stats: [
        { value: "200+", label: "business processes supported" },
        { value: "−60%", label: "manual work eliminated" },
        { value: "7+", label: "years of experience" },
        { value: "4", label: "languages spoken" }
      ]
    },
    about: {
      title: "About Me",
      description: "Software engineer specializing in AI & automation. I develop solutions that turn data into business value."
    },
    expertise: {
      ai: "Power Apps",
      automation: "Power Automate",
      prototyping: "Power BI & SQL",
      machineLearning: "Azure & Integrations"
    },
    blog: {
      title: "Blog & Articles",
      backToList: "Back to list",
      readMore: "Read article"
    }
  }
};
